/* ============================================================
   LIMN CRO HEADER — STABLE MOBILE DRAWER

   ONE controller only.

   Mobile menu:
   - one tap opens
   - one tap on hamburger closes
   - X closes
   - tap outside closes
   - swipe left closes
   - scrolling the page does NOT change menu state
   - no menu blur for now
   - no menu scroll-lock for now
   - current page position is never changed

   Search overlay remains separate.
   ============================================================ */

(function () {

  var header = document.querySelector('[data-cro-header]');

  if (!header) {
    return;
  }


  var body = document.body;

  var details =
    header.querySelector('[data-mobile-menu]');

  var trigger =
    header.querySelector('[data-mobile-menu-trigger]');

  var icon =
    header.querySelector('[data-mobile-menu-icon]');

  var drawer =
    header.querySelector('[data-nav]');

  var overlay =
    header.querySelector('[data-cro-overlay]');

  var searchOverlay =
    header.querySelector('[data-cro-search]');


  /* ============================================================
     REMOVE ANY OLD / NATIVE LOCK STATE
     ============================================================ */

  function clearMenuLocks() {

    body.classList.remove(
      'is-active',
      'blocked-scroll',
      'scroll-locked',
      'cro-locked'
    );

  }


  /* ============================================================
     MENU STATE
     ============================================================ */

  function menuIsOpen() {

    return !!(
      details &&
      details.open
    );

  }


  function openMenu() {

    if (
      !details ||
      !drawer
    ) {
      return;
    }


    /*
      Close search first.
    */

    closeSearch();


    /*
      Never use the menu blur for now.
    */

    if (overlay) {
      overlay.classList.remove('is-open');
    }


    /*
      Do NOT lock body scrolling.
      This avoids Safari moving the page to the top.
    */

    clearMenuLocks();


    /*
      Native <details> controls the CSS transform.
    */

    details.open = true;


    /*
      Turbo's base stylesheet separately controls opacity using
      data-animation-state.

      Set it ourselves so the drawer can never be clickable but
      invisible.
    */

    drawer.setAttribute(
      'data-animation-state',
      'open'
    );

    drawer.removeAttribute(
      'data-animation'
    );


    if (icon) {
      icon.classList.add('open');
    }


    if (trigger) {

      trigger.setAttribute(
        'aria-expanded',
        'true'
      );

    }

  }


  function closeMenu() {

    if (
      !details ||
      !drawer
    ) {
      return;
    }


    /*
      Change Turbo's opacity state first.
    */

    drawer.setAttribute(
      'data-animation-state',
      'closed'
    );

    drawer.removeAttribute(
      'data-animation'
    );


    /*
      Then close <details>.
      This triggers the existing CSS slide-out.
    */

    details.open = false;


    if (icon) {
      icon.classList.remove('open');
    }


    if (trigger) {

      trigger.setAttribute(
        'aria-expanded',
        'false'
      );

    }


    if (overlay) {
      overlay.classList.remove('is-open');
    }


    clearMenuLocks();

  }


  function toggleMenu() {

    if (menuIsOpen()) {

      closeMenu();

    } else {

      openMenu();

    }

  }


  /* ============================================================
     HAMBURGER
     ============================================================ */

  /*
    IMPORTANT:

    Turbo has its own click listener on this same hamburger.

    We intercept the click in CAPTURE phase before Turbo receives
    it. Otherwise both systems toggle the drawer and create the
    double-tap / disappearing-menu behaviour.
  */

  if (trigger) {

    trigger.addEventListener(
      'click',
      function (event) {

        event.preventDefault();

        event.stopPropagation();

        if (
          typeof event.stopImmediatePropagation ===
          'function'
        ) {

          event.stopImmediatePropagation();

        }


        toggleMenu();

      },
      true
    );

  }


  /* ============================================================
     X CLOSE BUTTON
     ============================================================ */

  document.addEventListener(
    'click',
    function (event) {

      var closeButton =
        event.target.closest(
          '[data-cro-drawer-close]'
        );


      if (
        !closeButton ||
        !header.contains(closeButton)
      ) {
        return;
      }


      event.preventDefault();

      event.stopPropagation();


      if (
        typeof event.stopImmediatePropagation ===
        'function'
      ) {

        event.stopImmediatePropagation();

      }


      closeMenu();

    },
    true
  );


  /* ============================================================
     TAP OUTSIDE DRAWER
     ============================================================ */

  document.addEventListener(
    'click',
    function (event) {

      if (!menuIsOpen()) {
        return;
      }


      /*
        Inside drawer = normal interaction.
      */

      if (
        drawer &&
        drawer.contains(event.target)
      ) {
        return;
      }


      /*
        Hamburger click is handled above.
      */

      if (
        trigger &&
        trigger.contains(event.target)
      ) {
        return;
      }


      closeMenu();

    }
  );


  /* ============================================================
     SWIPE LEFT TO CLOSE
     ============================================================ */

  if (drawer) {

    var touchStartX = 0;
    var touchStartY = 0;


    drawer.addEventListener(
      'touchstart',
      function (event) {

        if (
          !event.touches ||
          !event.touches.length
        ) {
          return;
        }


        touchStartX =
          event.touches[0].clientX;

        touchStartY =
          event.touches[0].clientY;

      },
      {
        passive: true
      }
    );


    drawer.addEventListener(
      'touchend',
      function (event) {

        if (
          !event.changedTouches ||
          !event.changedTouches.length
        ) {
          return;
        }


        var endX =
          event.changedTouches[0].clientX;

        var endY =
          event.changedTouches[0].clientY;


        var horizontal =
          endX - touchStartX;

        var vertical =
          Math.abs(
            endY - touchStartY
          );


        /*
          A deliberate swipe towards the left.
          Vertical menu scrolling remains unaffected.
        */

        if (
          horizontal < -55 &&
          vertical < 80
        ) {

          closeMenu();

        }

      },
      {
        passive: true
      }
    );

  }


  /* ============================================================
     SEARCH
     ============================================================ */

  function openSearch() {

    if (!searchOverlay) {
      return;
    }


    closeMenu();


    searchOverlay.classList.add(
      'is-open'
    );


    searchOverlay.setAttribute(
      'aria-hidden',
      'false'
    );


    if (overlay) {

      overlay.classList.add(
        'is-open'
      );

    }


    body.classList.add(
      'cro-locked'
    );


    var input =
      searchOverlay.querySelector(
        '[data-search-input]'
      );


    if (input) {

      setTimeout(
        function () {

          input.focus();

        },
        60
      );

    }

  }


  function closeSearch() {

    if (!searchOverlay) {
      return;
    }


    searchOverlay.classList.remove(
      'is-open'
    );


    searchOverlay.setAttribute(
      'aria-hidden',
      'true'
    );


    if (overlay) {

      overlay.classList.remove(
        'is-open'
      );

    }


    body.classList.remove(
      'cro-locked'
    );

  }


  header
    .querySelectorAll(
      '[data-cro-search-open]'
    )
    .forEach(
      function (button) {

        button.addEventListener(
          'click',
          function (event) {

            event.preventDefault();

            openSearch();

          }
        );

      }
    );


  header
    .querySelectorAll(
      '[data-cro-search-close]'
    )
    .forEach(
      function (button) {

        button.addEventListener(
          'click',
          function (event) {

            event.preventDefault();

            closeSearch();

          }
        );

      }
    );


  if (overlay) {

    overlay.addEventListener(
      'click',
      function () {

        closeSearch();

      }
    );

  }


  /* ============================================================
     ESCAPE
     ============================================================ */

  document.addEventListener(
    'keydown',
    function (event) {

      if (
        event.key === 'Escape' ||
        event.keyCode === 27
      ) {

        closeMenu();
        closeSearch();

      }

    }
  );


  /* ============================================================
     STICKY HEADER
     ============================================================ */

  function onScroll() {

    header.classList.toggle(
      'cro-header--stuck',
      window.scrollY > 8
    );

  }


  window.addEventListener(
    'scroll',
    onScroll,
    {
      passive: true
    }
  );


  onScroll();


  /* ============================================================
     HEADER HEIGHT
     ============================================================ */

  function syncHeaderHeight() {

    var height =
      header.offsetHeight;


    if (height > 0) {

      document.documentElement.style.setProperty(
        '--cro-header-total-h',
        height + 'px'
      );

    }

  }


  syncHeaderHeight();


  window.addEventListener(
    'resize',
    syncHeaderHeight
  );


  window.addEventListener(
    'load',
    syncHeaderHeight
  );


  if (
    typeof ResizeObserver ===
    'function'
  ) {

    new ResizeObserver(
      syncHeaderHeight
    ).observe(header);

  }


  /* ============================================================
     ANNOUNCEMENT BAR
     ============================================================ */

  var announcement =
    header.querySelector(
      '[data-cro-announce]'
    );


  if (announcement) {

    var slides =
      announcement.querySelectorAll(
        '.cro-announce__slide'
      );


    var previousButton =
      announcement.querySelector(
        '[data-announce-prev]'
      );


    var nextButton =
      announcement.querySelector(
        '[data-announce-next]'
      );


    if (slides.length < 2) {

      if (previousButton) {
        previousButton.style.display = 'none';
      }


      if (nextButton) {
        nextButton.style.display = 'none';
      }

    } else {

      var activeIndex = 0;
      var timer;


      function go(index) {

        slides[
          activeIndex
        ].classList.remove(
          'is-active'
        );


        activeIndex =
          (
            index +
            slides.length
          ) %
          slides.length;


        slides[
          activeIndex
        ].classList.add(
          'is-active'
        );

      }


      function play() {

        clearInterval(timer);


        timer =
          setInterval(
            function () {

              go(
                activeIndex + 1
              );

            },
            4500
          );

      }


      if (nextButton) {

        nextButton.addEventListener(
          'click',
          function () {

            go(
              activeIndex + 1
            );

            play();

          }
        );

      }


      if (previousButton) {

        previousButton.addEventListener(
          'click',
          function () {

            go(
              activeIndex - 1
            );

            play();

          }
        );

      }


      play();

    }

  }


  /* ============================================================
     INITIAL CLEAN STATE
     ============================================================ */

  clearMenuLocks();


  if (overlay) {

    overlay.classList.remove(
      'is-open'
    );

  }


  if (details) {

    details.open = false;

  }


  if (drawer) {

    drawer.setAttribute(
      'data-animation-state',
      'closed'
    );

    drawer.removeAttribute(
      'data-animation'
    );

  }


  if (icon) {
    icon.classList.remove('open');
  }


  if (trigger) {

    trigger.setAttribute(
      'aria-expanded',
      'false'
    );

  }

})();